import styled from "styled-components";

export const StyledStatusDescription = styled.h2`
  text-align: center;
`;

export const StyledStatusText = styled.p`
  text-align: center;
`;
